export const associationStatus = [
    {id:0 , name:'canceled', color: '#d52a1e'},
    {id:1 , name:'active', color: '#479409'},
    {id:2 , name:'suspended', color: '#b2b2b2'}
]

export const comparative = [
    {id:0 , name:'equal'},
    {id:1 , name:'greaterThan'},
    {id:2 , name:'lessThan'},
]

export const vehicleStatuses = [
    { id: 0, name: 'canceled' },
    { id: 1, name: 'active' },
    { id: 2, name: 'suspended' }
]

export const driverStatuses = [
    { id: 0, name: 'canceled' },
    { id: 1, name: 'active' },
    { id: 2, name: 'suspended' },
    { id: 3, name: 'vacation' },
    { id: 4, name: 'permission' },
]

export const registerTypes = [
    { id: 'automatic', name: 'Automatic' },
    { id: 'manual', name: 'Manual' }
]

export const ownershipStatuses = [
    { id: 1, name: 'Own Fleet' },
    { id: 2, name: 'Rent' }
]

export const paymentMethods = [
    { id: 1, name: 'Cash' },
    { id: 2, name: 'Credit' },
    { id: 3, name: 'Credit card' },
    { id: 4, name: 'Check' },
    { id: 5, name: 'Bank transfer' }
]

export const fineAppealStatuses = [
    { id: 0, name: 'Cancelled' },
    { id: 1, name: 'On going' },
    { id: 2, name: 'Acepted' },
    { id: 3, name: 'Rejected' },
    { id: 4, name: 'Restored' }
]

export const finesStages = [
    { id: 1, name: 'all' },
    { id: 10, name: 'Notified' },
    { id: 20, name: 'Identified' },
    { id: 30, name: 'Assigned' },
    { id: 40, name: 'Indicated' },
    { id: 50, name: 'Billed' },
    { id: 120, name: 'Under appeal' },
    { id: 100, name: 'Installment' },
    { id: 110, name: 'Refunded' }
]

export const cardStatuses = [
    { id: 0, name: 'Canceled' },
    { id: 1, name: 'Active' },
    { id: 2, name: 'Blocked' }
]